export class Criteria {
    creditos: number;
    materias: any;
    
}
